'use strict';

var analytics = angular.module('common.analytics', [
  'common.identity'
]);

var AnalyticsConfig = require('./AnalyticsConfig');
var AnalyticsService = require('./AnalyticsService');

analytics.config(AnalyticsConfig);

analytics.service('AnalyticsService', [
  '$window',
  'IdentityService',
  'sbAnalytics',
  '$location',
  AnalyticsService
]);

analytics.run(['$location', '$rootScope', '$state', 'AnalyticsService', function ($location, $rootScope, $state, AnalyticsService) {
  AnalyticsService.identify();
  // Track clickthroughs from emails
  $rootScope.$on('$locationChangeStart', function (e, newUrl) {
    var emailTrackingCode  = newUrl.match(/gl=([^&]*)/);
    if (emailTrackingCode) {
      var link = newUrl.split(emailTrackingCode[0])[0].split('?')[0];
      var emailTrackingData = {
        link: link,
        email: emailTrackingCode[1]
      };

      if($state.current.name === 'dash.map') {
        if(emailTrackingCode[0] === 'gl') {
          $location.url($location.absUrl());
        } else {
          $location.url($location.path());
        }
      } else if (emailTrackingCode[0] === 'gl') {
        $location.url($location.absUrl());
      }

      AnalyticsService.track('[CORE] Email', 'Click-through', emailTrackingData);
    }
  });
}]);



// WEBPACK FOOTER //
// ./src/common/analytics/index.js